export default "__VITE_ASSET__BdqYRLxw__"